/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { GlobalContext } from 'shared/context/store';

const AuthRoute = ({ component: Component, ...rest }) => {
  const { state: { rootState } } = useContext(GlobalContext);
  const { clientData } = rootState;
  if (clientData.token) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Component {...props} />
        )}
      />
    );
  }
  return (
    <Redirect
      to={{
        pathname: '/',
      }}
    />
  );
};

export default AuthRoute;
